<section
  class="events-dashboard"
  [attr.inert]="browserTabs.claimInteractionLocked() ? '' : null"
>
  <eventq-site-selection-popover
    [open]="popoverOpen()"
    [title]="popoverTitle()"
    [confirmLabel]="popoverConfirmLabel()"
    [sites]="filteredSites()"
    [selectedSiteId]="eventsActionSelectedSiteId()"
    [searchQuery]="eventsActionSearchQuery()"
    [loading]="actionSitesLoading()"
    [skeletonCount]="5"
    (closed)="onPopoverClose()"
    (searchQueryChange)="onSearchQueryChange($event)"
    (selectedSiteIdChange)="onSelectedSiteChange($event)"
    (confirm)="onPopoverConfirm($event)"
  />

  <eventq-sites-status-list-popover
    [open]="statusListOpen()"
    [variant]="sitesStatusListPopover() ?? 'armed'"
    [sites]="statusListSites()"
    [searchQuery]="sitesStatusListSearchQuery()"
    [allowSiteSelect]="canSelectStatusListSite()"
    [loading]="siteLocationsResource.isLoading() && !siteLocationsResource.hasValue()"
    [skeletonCount]="5"
    [anchor]="statusListAnchor()"
    (closed)="onSitesStatusListClose()"
    (searchQueryChange)="onSitesStatusListSearchChange($event)"
    (siteSelect)="onSitesStatusSiteSelect($event)"
  />

  <eventq-disarm-site-popover
    [open]="disarmPopoverOpen()"
    [siteName]="selectedArmDisarmSite()?.name ?? ''"
    [reasons]="disarmReasonsResource.value()?.items ?? []"
    [reasonId]="siteDisarmReasonId()"
    [disarmFor]="siteDisarmFor()"
    [fixedDurationMinutes]="siteDisarmFixedDurationMinutesForUi()"
    [fixedDurationCustom]="siteDisarmFixedDurationCustom()"
    [fixedDurationCustomDraft]="siteDisarmFixedDurationCustomDraft()"
    [untilAt]="siteDisarmUntilAt()"
    [ianaTimeZone]="disarmSiteTimeZone()"
    [submitDisabled]="armDisarmSubmitting()"
    [anchor]="disarmPopoverAnchor()"
    reasonMenuPlacement="bottom-start"
    (closed)="onArmDisarmClose()"
    (reasonIdChange)="onDisarmReasonChange($event)"
    (disarmForChange)="onDisarmForChange($event)"
    (fixedDurationMinutesChange)="onDisarmFixedDurationChange($event)"
    (fixedDurationCustomChange)="onDisarmFixedDurationCustomChange($event)"
    (fixedDurationCustomDraftChange)="onDisarmFixedDurationCustomDraftChange($event)"
    (untilAtChange)="onDisarmUntilAtChange($event)"
    (confirm)="onDisarmConfirm($event)"
  />

  @if (!browserTabs.expanded()) {
    <div class="events-dashboard__controls">
      @if (canShowEventQueueToggle()) {
        <eventq-boolean-toggle
          label="Show Event Queue"
          [checked]="showEventQueue()"
          (checkedChange)="setShowEventQueue($event)"
        />
      }
      @if (siteStats.hasValue()) {
        <div class="events-dashboard__stats">
          <eventq-site-stat-flag
            #armedSitesTrigger
            [armed]="true"
            [count]="siteStats.value().armedCount"
            (pressed)="openSitesStatusList('armed')"
          />
          <eventq-site-stat-flag
            #disarmedSitesTrigger
            [armed]="false"
            [count]="siteStats.value().disarmedCount"
            (pressed)="openSitesStatusList('disarmed')"
          />
        </div>
      } @else if (siteStats.isLoading()) {
        <p class="events-dashboard__stats-status" role="status">Loading site stats…</p>
      } @else if (siteStats.error()) {
        <p class="events-dashboard__stats-status" role="alert">Unable to load site stats.</p>
      }
    </div>
  }

  @if (showOperatorWorkspace()) {
    <div class="events-dashboard__content">
      <div class="events-dashboard__tables">
        @if (showEventQueue()) {
          <app-events-queue-section (eventRowActivate)="onQueueEventActivate($event)" />
        }

        @if (canPark()) {
          <app-parked-events-section (eventRowActivate)="onParkedEventActivate($event)" />
        }
        <app-patrol-list-section />
        <app-events-in-process-section />
      </div>

      <app-event-action-panel
        [queueCount]="queueCount()"
        [actionsDisabled]="browserTabs.claimInteractionLocked()"
        (processEvent)="onProcessEvent()"
        (manualPatrol)="onManualPatrol()"
        (siteCheck)="onSiteCheck()"
      />
    </div>
  }
</section>
